(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3185],{

/***/ 58571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ curriculum; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(81333);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/views/GrowthMasters/hooks/useInitialCookie.tsx
var useInitialCookie = __webpack_require__(86052);
// EXTERNAL MODULE: ./src/contexts/gatedContent.ts
var gatedContent = __webpack_require__(62906);
// EXTERNAL MODULE: ../../libs/contexts/staticSiteBackend.ts
var contexts_staticSiteBackend = __webpack_require__(86708);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/Loader/index.ts
var Loader = __webpack_require__(37438);
// EXTERNAL MODULE: ../../libs/api/routes/growthMasters/queries/index.ts + 2 modules
var queries = __webpack_require__(94650);
// EXTERNAL MODULE: ./src/views/GrowthMasters/components/Layout/Layout.tsx + 5 modules
var Layout = __webpack_require__(63946);
// EXTERNAL MODULE: ./src/views/GrowthMasters/components/WantToLearnMore/WantToLearnMore.tsx
var WantToLearnMore = __webpack_require__(60114);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/index.ts + 9 modules
var Select = __webpack_require__(44502);
// EXTERNAL MODULE: ../../libs/matcha/components/Select/useSelect/index.ts + 3 modules
var useSelect = __webpack_require__(27431);
// EXTERNAL MODULE: ../../libs/matcha/components/Input/index.ts + 2 modules
var Input = __webpack_require__(94261);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Common.ts + 14 modules
var Common = __webpack_require__(6580);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/CurriculumPage/Filters/FilterSelect.tsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var FilterSelect = function FilterSelect(_ref) {
  var options = _ref.options,
      id = _ref.id,
      onSelect = _ref.onSelect,
      placeholder = _ref.placeholder,
      disabled = _ref.disabled;

  var _useSelect = (0,useSelect/* default */.Z)({
    options: options,
    id: id,
    onSelect: onSelect,
    config: {
      multiselect: true,
      mobileConfirmationBehaviour: true
    }
  }),
      state = _useSelect.state,
      getControlProps = _useSelect.getControlProps,
      filteredOptions = _useSelect.filteredOptions,
      getSelectProps = _useSelect.getSelectProps;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input/* default */.Z, _objectSpread(_objectSpread({
      name: id,
      type: "search",
      resetable: state.filterValue !== "",
      clearIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* ClearSelect */.kr, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ClearIcon */.Rk, {
          size: "small"
        })
      }),
      rightSecondIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Common/* ChevronDownIcon */.v4, {})
    }, getControlProps({
      placeholder: placeholder,
      counter: true
    })), {}, {
      "aria-label": placeholder,
      disabled: disabled
    })), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Select/* default */.ZP, _objectSpread({
      id: "select-base-".concat(id),
      name: "select-base-".concat(id),
      options: options,
      filteredOptions: filteredOptions,
      displayMode: state.displayMode,
      open: state.open,
      listItemComponent: Select/* MenuItemWithCheckbox */.N1
    }, getSelectProps()))]
  });
};

/* harmony default export */ var Filters_FilterSelect = (FilterSelect);

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eq3j4gz0"
} : 0)("color:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.palette.twilio.gray[80];
}, ";z-index:1;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/views/GrowthMasters/CurriculumPage/Filters/Filters.tsx







var toOptionProps = function toOptionProps(filter) {
  var title = filter.title,
      id = filter.id;
  return {
    value: id,
    text: title
  };
};

var Filters = function Filters(_ref) {
  var _ref$onFilterChange = _ref.onFilterChange,
      onFilterChange = _ref$onFilterChange === void 0 ? function () {
    return null;
  } : _ref$onFilterChange,
      filters = _ref.filters;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionBase, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledColumnTrack, {
        gap: "small",
        columns: 1,
        overrides: {
          lg: filters === null || filters === void 0 ? void 0 : filters.length
        },
        children: filters === null || filters === void 0 ? void 0 : filters.map(function (_ref2) {
          var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
              key = _ref3[0],
              filter = _ref3[1];

          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Filters_FilterSelect, {
            id: key,
            placeholder: filter.title,
            options: filter.items.map(toOptionProps),
            onSelect: function onSelect(selectedOptions) {
              return onFilterChange(key, selectedOptions);
            }
          }, key);
        })
      })
    })
  });
};

var StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "ex6tg9p1"
} : 0)("overflow:visible;", Section/* Wrapper */.im, "{justify-content:unset;padding-top:0;padding-bottom:0;row-gap:24px;}" + ( true ? "" : 0));

var StyledColumnTrack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(ColumnTrack/* default */.Z,  true ? {
  target: "ex6tg9p0"
} : 0)("max-width:520px;row-gap:8px;margin:0 auto;margin-bottom:8px;", function (_ref4) {
  var theme = _ref4.theme;
  return theme.breakpoints.up("xl");
}, "{padding:0 80px;}" + ( true ? "" : 0));

/* harmony default export */ var Filters_Filters = (Filters);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/CurriculumPage/GrowthMastersCurriculum/GrowthMastersCurriculum.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }





var copy = {
  heading: "Growth Masters Curriculum",
  description: "Each on-demand lesson is led by a product or growth expert and goes deep on a specific topic."
};

var GrowthMastersCurriculum = function GrowthMastersCurriculum() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GrowthMastersCurriculum_StyledSectionBase, {
    variant: "centered",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionCopy, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
        centered: true,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Heading */.X6, {
          tag: "h1",
          variant: "h1",
          children: copy.heading
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
          variant: "pLarge",
          tag: "h2",
          children: copy.description
        })]
      })
    })
  });
};

var GrowthMastersCurriculum_StyledSectionBase = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* default */.ZP,  true ? {
  target: "e5e8lsd1"
} : 0)(Section/* Wrapper */.im, "{gap:0;}" + ( true ? "" : 0));

var StyledSectionCopy = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Section/* Copy */.CK,  true ? {
  target: "e5e8lsd0"
} : 0)( true ? {
  name: "1ib8u6k",
  styles: "max-width:844px"
} : 0);

/* harmony default export */ var GrowthMastersCurriculum_GrowthMastersCurriculum = (GrowthMastersCurriculum);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../libs/utils/useNextPageTrigger/index.ts + 1 modules
var useNextPageTrigger = __webpack_require__(78299);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/CurriculumPage/hooks/useCurriculumGrid.tsx




function useCurriculumGrid_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useCurriculumGrid_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useCurriculumGrid_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useCurriculumGrid_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




var useCurriculumGrid = function useCurriculumGrid(filtersState, triggerComponent) {
  var _data$pages$length;

  var _useCurriculumQuery = (0,queries/* useCurriculumQuery */._6)({
    args: [useCurriculumGrid_objectSpread({}, filtersState)]
  }),
      data = _useCurriculumQuery.data,
      isLoading = _useCurriculumQuery.isLoading,
      hasNextPage = _useCurriculumQuery.hasNextPage,
      fetchNextPage = _useCurriculumQuery.fetchNextPage,
      error = _useCurriculumQuery.error,
      isFetchingNextPage = _useCurriculumQuery.isFetchingNextPage;

  var pages = (0,react.useMemo)(function () {
    var _data$pages$flatMap, _data$pages;

    return (_data$pages$flatMap = data === null || data === void 0 ? void 0 : (_data$pages = data.pages) === null || _data$pages === void 0 ? void 0 : _data$pages.flatMap(function (collection) {
      var _collection$items;

      return (_collection$items = collection === null || collection === void 0 ? void 0 : collection.items) !== null && _collection$items !== void 0 ? _collection$items : [];
    })) !== null && _data$pages$flatMap !== void 0 ? _data$pages$flatMap : [];
  }, [data === null || data === void 0 ? void 0 : data.pages]);
  var nextPageTrigger = (0,useNextPageTrigger/* default */.Z)({
    isLoading: isLoading,
    totalDownloadedPages: (_data$pages$length = data === null || data === void 0 ? void 0 : data.pages.length) !== null && _data$pages$length !== void 0 ? _data$pages$length : -1,
    hasNextPage: hasNextPage,
    error: error,
    onNextPage: function onNextPage() {
      return (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetchNextPage();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    loadMargin: "0%",
    NextPageTrigger: triggerComponent
  });
  return {
    pages: pages,
    isLoading: isLoading,
    nextPageTrigger: nextPageTrigger,
    isFetchingNextPage: isFetchingNextPage,
    hasNextPage: hasNextPage
  };
};
;// CONCATENATED MODULE: ./src/views/GrowthMasters/CurriculumPage/hooks/useFilters.ts



function useFilters_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function useFilters_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? useFilters_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : useFilters_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var useFilters = function useFilters(entries) {
  var _useState = (0,react.useState)(useFilters_objectSpread({}, entries.reduce(function (acc, _ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 1),
        key = _ref2[0];

    return useFilters_objectSpread(useFilters_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, []));
  }, {}))),
      filtersState = _useState[0],
      setFiltersState = _useState[1];

  var createHandler = function createHandler(key, setState) {
    return function (selected) {
      return setState(function (prev) {
        return useFilters_objectSpread(useFilters_objectSpread({}, prev), {}, (0,defineProperty/* default */.Z)({}, key, selected));
      });
    };
  };

  var selectHandlers = entries.reduce(function (acc, _ref3) {
    var _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 1),
        key = _ref4[0];

    return useFilters_objectSpread(useFilters_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, createHandler(key, setFiltersState)));
  }, {});
  return {
    filtersState: filtersState,
    selectHandlers: selectHandlers
  };
};
// EXTERNAL MODULE: ./src/views/GrowthMasters/components/Card/Card.tsx
var Card = __webpack_require__(79831);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/CurriculumPage/Cards/Cards.tsx






var Cards = function Cards(_ref) {
  var lessons = _ref.lessons;

  var _useGatedContent = (0,gatedContent/* useGatedContent */.v4)(),
      showContent = _useGatedContent.showContent;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* default */.ZP, {
    variant: "noCopy",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
        columns: 1,
        overrides: {
          lg: 3
        },
        children: lessons.map(function (card, key) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.Z, {
            slug: card.slug,
            title: card.title,
            speaker: card.speaker,
            badges: card.badges,
            description: card.shortDescription,
            gated: !showContent
          }, card.title + key);
        })
      })
    })
  });
};

/* harmony default export */ var Cards_Cards = (Cards);
;// CONCATENATED MODULE: ./src/views/GrowthMasters/CurriculumPage/Curriculum.tsx


function Curriculum_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }














var Curriculum = function Curriculum() {
  var _useFiltersQuery = (0,queries/* useFiltersQuery */.s_)({
    args: []
  }),
      filters = _useFiltersQuery.data;

  var groupedFilterEntries = Object.entries(filters || {});

  var _useFilters = useFilters(groupedFilterEntries),
      filtersState = _useFilters.filtersState,
      selectHandlers = _useFilters.selectHandlers;

  var _useCurriculumGrid = useCurriculumGrid(filtersState),
      pages = _useCurriculumGrid.pages,
      nextPageTrigger = _useCurriculumGrid.nextPageTrigger,
      isLoading = _useCurriculumGrid.isLoading,
      hasNextPage = _useCurriculumGrid.hasNextPage,
      isFetchingNextPage = _useCurriculumGrid.isFetchingNextPage;

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Layout/* default */.Z, {
    pageName: "Curriculum",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GrowthMastersCurriculum_GrowthMastersCurriculum, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Filters_Filters, {
      filters: groupedFilterEntries,
      onFilterChange: function onFilterChange(filterId, selectedOptions) {
        return selectHandlers[filterId](selectedOptions);
      }
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Curriculum_Wrapper, {
      children: [!isLoading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cards_Cards, {
        lessons: pages
      }), isLoading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoaderWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loader/* default */.Z, {})
      }), hasNextPage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoaderWrapper, {
        compensateTopGutter: hasNextPage,
        children: isFetchingNextPage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loader/* default */.Z, {})
      }), nextPageTrigger]
    }), !hasNextPage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WantToLearnMore/* default */.Z, {})]
  });
};

var Curriculum_Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1b7nwm81"
} : 0)( true ? "" : 0);

var _ref =  true ? {
  name: "4nougu",
  styles: "padding:0;margin-top:-120px"
} : 0;

var LoaderWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1b7nwm80"
} : 0)("display:grid;align-items:center;justify-content:center;height:400px;padding:80px 0;margin:0 auto;", function (_ref2) {
  var compensateTopGutter = _ref2.compensateTopGutter;
  return compensateTopGutter && _ref;
}, ";" + ( true ? "" : 0));

/* harmony default export */ var CurriculumPage_Curriculum = (Curriculum);
;// CONCATENATED MODULE: ./src/pages/growth-masters/curriculum/index.tsx








var curriculum_Curriculum = function Curriculum() {
  var staticSiteBackend = (0,react.useMemo)(function () {
    return (0,contexts_staticSiteBackend/* createStaticSiteBackend */.I4)();
  }, []);

  var _useInitialCookie = (0,useInitialCookie/* default */.Z)(),
      _useInitialCookie2 = (0,slicedToArray/* default */.Z)(_useInitialCookie, 3),
      showContent = _useInitialCookie2[0],
      isLoading = _useInitialCookie2[1],
      updateRegistered = _useInitialCookie2[2];

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(contexts_staticSiteBackend/* StaticSiteBackendProvider */.D1, {
    value: staticSiteBackend,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(gatedContent/* GatedContentProvider */.$8, {
      value: {
        showContent: showContent,
        updateRegistered: updateRegistered
      },
      children: isLoading ? null : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CurriculumPage_Curriculum, {})
    })
  });
};

var __N_SSG = true;
/* harmony default export */ var curriculum = (curriculum_Curriculum);

/***/ }),

/***/ 39896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ createClient; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(20406);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(28526);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ../../libs/utils/retry/retry.ts



var wait = function wait(waitTime) {
  return new Promise(function (resolve) {
    setTimeout(resolve, waitTime);
  });
};

var numberSuffixes = ["st", "nd", "rd"];

var functionFailedText = function functionFailedText(iteration) {
  var _numberSuffixes$itera;

  return "Function failed. Retrying ".concat(iteration + 1).concat((_numberSuffixes$itera = numberSuffixes[iteration]) !== null && _numberSuffixes$itera !== void 0 ? _numberSuffixes$itera : "th", " time...");
};

var allRetriesFailedText = function allRetriesFailedText(retriesCount, errors) {
  return "Function failed too many times. Tired ".concat(retriesCount, " time").concat(retriesCount > 1 ? "s" : "", ".\nThrown errors:\n").concat(errors.map(function (e) {
    return e.toString();
  }).join("\n\n"), "\n");
};
/* eslint-disable no-await-in-loop */

/**
 * Retry function call
 * @param fn - The function to be called
 * @param options - The options object
 * @param options.times - Total amount of function calls. First function call is included.
 * @param options.waitTime - Wait time between retries in milliseconds
 * @returns The function with retries
 */


var retry = function retry(fn, _ref) {
  var times = _ref.times,
      waitTime = _ref.waitTime;
  return /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var errors,
        i,
        _args = arguments;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            errors = [];
            i = 0;

          case 2:
            if (!(i < times)) {
              _context.next = 19;
              break;
            }

            _context.prev = 3;
            _context.next = 6;
            return fn.apply(void 0, _args);

          case 6:
            return _context.abrupt("return", _context.sent);

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            console.log(functionFailedText(i));

            if (!(i + 1 < times)) {
              _context.next = 15;
              break;
            }

            _context.next = 15;
            return wait(waitTime);

          case 15:
            errors.push(_context.t0);

          case 16:
            i++;
            _context.next = 2;
            break;

          case 19:
            throw new Error(allRetriesFailedText(times, errors));

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 9]]);
  }));
};
/* eslint-enable no-await-in-loop */


/* harmony default export */ var retry_retry = (retry);
;// CONCATENATED MODULE: ../../libs/utils/retry/index.ts

;// CONCATENATED MODULE: ../../libs/api/staticSiteBackend/client.ts
/* provided dependency */ var process = __webpack_require__(34406);



var OMIT_CACHE_PARAMETER = "omitCache";
var CONTENT_PREVIEW_PARAMETER = "contentPreview";

var isCacheDisabled = function isCacheDisabled() {
  return process.env.CI;
};

var createClient = function createClient() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$retry = _ref.retry,
      retryOptions = _ref$retry === void 0 ? {
    times: 3,
    waitTime: 1000
  } : _ref$retry;

  function get(_x, _x2) {
    return _get.apply(this, arguments);
  }

  function _get() {
    _get = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(url, options) {
      var fullUserUrl, fullUrl, isOmitCacheParamMissing, startTime, response, json, endTime, requestTime;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!url.startsWith("/")) {
                _context.next = 20;
                break;
              }

              fullUserUrl = "".concat("https://preview.segment.build/backend").concat(url);
              fullUrl = new URL(fullUserUrl);
              isOmitCacheParamMissing = !fullUrl.searchParams.has(OMIT_CACHE_PARAMETER);

              if (isOmitCacheParamMissing && isCacheDisabled()) {
                fullUrl.searchParams.append(OMIT_CACHE_PARAMETER, "");
              }

              if (process.env.IS_CONTENTFUL_PREVIEW_BRANCH === "true") {
                fullUrl.searchParams.append(CONTENT_PREVIEW_PARAMETER, "true");
              }

              startTime = Date.now();
              _context.next = 9;
              return fetch(fullUrl.toString(), options);

            case 9:
              response = _context.sent;

              if (!response.ok) {
                _context.next = 17;
                break;
              }

              _context.next = 13;
              return response.json();

            case 13:
              json = _context.sent;

              if (!(options !== null && options !== void 0 && options.responseHeaders)) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return", {
                data: json,
                headers: response.headers
              });

            case 16:
              return _context.abrupt("return", json);

            case 17:
              endTime = Date.now();
              requestTime = (endTime - startTime) / 1000;
              throw new Error("HTTP error ".concat(response.status, ": ").concat(response.statusText, "\nwhile trying to fetch: ").concat(fullUrl, "\nresponse returned after: ").concat(requestTime, " seconds\n      "));

            case 20:
              throw new Error("Client supports only absolute paths (starting with /)");

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _get.apply(this, arguments);
  }

  var retryGet = retry_retry(get, retryOptions);
  return {
    get: retryGet
  };
};



/***/ }),

/***/ 4203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Image; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/Image.views.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)((image_default()),  true ? {
  target: "eulst6f0"
} : 0)( true ? {
  name: "11726p1",
  styles: "height:auto;position:relative;margin:0 auto;display:block"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/Image.tsx


var _excluded = ["src", "alt", "width", "height", "unoptimized", "loader"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var imageLoader = function imageLoader(_ref) {
  var src = _ref.src;
  return "".concat(src);
};

var Image = function Image(_ref2) {
  var src = _ref2.src,
      alt = _ref2.alt,
      width = _ref2.width,
      height = _ref2.height,
      _ref2$unoptimized = _ref2.unoptimized,
      unoptimized = _ref2$unoptimized === void 0 ? true : _ref2$unoptimized,
      loader = _ref2.loader,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImage, _objectSpread(_objectSpread({
    loader: loader || imageLoader,
    width: width,
    height: height,
    src: src,
    alt: alt
  }, props), {}, {
    unoptimized: loader ? false : unoptimized
  }));
};
;// CONCATENATED MODULE: ../../libs/matcha/components/Image/index.ts


/***/ }),

/***/ 9642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _segment_tracking_scripts_cookies__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16297);



var useTrustArcLink = function useTrustArcLink() {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      trustArcEnabled = _useState[0],
      setTrustArcEnabled = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var wt = window;

    if (wt.truste) {
      var consent = (0,_segment_tracking_scripts_cookies__WEBPACK_IMPORTED_MODULE_1__/* .getCookie */ .ej)("notice_behavior");

      if (consent !== "none") {
        setTrustArcEnabled(true);
      }
    }
  }, []);
  return trustArcEnabled;
};

/* harmony default export */ __webpack_exports__["Z"] = (useTrustArcLink);

/***/ }),

/***/ 1959:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/**
 * A helper function to generate the path to an image from Contentful.
 * @param props.src - The path to the image
 * @param props.width - The width of the image
 * @param props.quality - The quality of the image
 * @returns The path to the image with the width and quality parameters
 */
var contentfulImageLoader = function contentfulImageLoader(_ref) {
  var src = _ref.src,
      width = _ref.width,
      quality = _ref.quality;
  return "".concat(src, "?w=").concat(width, "&q=").concat(quality || 75);
};

/* harmony default export */ __webpack_exports__["Z"] = (contentfulImageLoader);

/***/ }),

/***/ 83194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useIntersectionObserver_useIntersectionObserver; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utils/useEventCallback/index.ts
var useEventCallback = __webpack_require__(93026);
;// CONCATENATED MODULE: ../../libs/utils/useIntersectionObserver/useIntersectionObserver.ts



var isRef = function isRef(ref) {
  return typeof ref !== "string";
};

var validSelector = function validSelector(slug) {
  var selector = slug.trim();

  if (selector && selector.match(/^\d/)) {
    selector = selector.replace(/^[0-9]+/, "");
    selector = selector.startsWith("-") ? selector.replace("-", "") : selector;
  }

  return selector;
};
/**
 * A hook to observe elements in the viewport
 * @param refs - An array of refs or selectors
 * @param callback - The function to call when an element is intersecting
 * @param options - The options for the IntersectionObserver
 * @returns An object containing the update function to update the observed elements and the observer reference
 */


var useIntersectionObserver = function useIntersectionObserver(refs, callback, options) {
  var observerRef = (0,react.useRef)();
  var currentlyObserved = (0,react.useRef)(Array.from({
    length: refs.length
  }).fill(null));

  var _useState = (0,react.useState)(0),
      updateCount = _useState[0],
      setUpdateCount = _useState[1];

  var callbackHandle = (0,useEventCallback/* default */.Z)(callback, []);
  (0,react.useEffect)(function () {
    var intersectionObserver = new IntersectionObserver(callbackHandle, options);
    observerRef.current = intersectionObserver;
    refs.forEach(function (ref, index) {
      var selector = !isRef(ref) && validSelector(ref);
      var element = isRef(ref) ? ref.current : document.querySelector("#".concat(selector));

      if (element && currentlyObserved.current) {
        intersectionObserver.observe(element);
        currentlyObserved.current[index] = element;
      }
    });
    return function () {
      intersectionObserver.disconnect();
      currentlyObserved.current = null;
    };
  }, [updateCount, callbackHandle]);
  var update = (0,react.useCallback)(function () {
    return setUpdateCount(function (state) {
      return ++state;
    });
  }, []); // Update observed element
  // JSX is changing and observed element can be mounted and unmounted from jsx tree
  // This effect takes care of updating currently observed element to newest reference value

  (0,react.useEffect)(function () {
    refs.forEach(function (ref, index) {
      var selector = !isRef(ref) && validSelector(ref);
      var element = isRef(ref) ? ref.current : document.querySelector("#".concat(selector));

      if (observerRef.current && currentlyObserved.current) {
        var areDifferent = currentlyObserved.current[index] !== element;

        if (currentlyObserved.current[index] && areDifferent && isRef(ref)) {
          var _observerRef$current;

          (_observerRef$current = observerRef.current) === null || _observerRef$current === void 0 ? void 0 : _observerRef$current.unobserve(currentlyObserved.current[index]);
          currentlyObserved.current[index] = null;
        }

        if (areDifferent && element && isRef(ref)) {
          var _observerRef$current2;

          (_observerRef$current2 = observerRef.current) === null || _observerRef$current2 === void 0 ? void 0 : _observerRef$current2.observe(element);
          currentlyObserved.current[index] = element;
        }
      }
    });
  });
  return {
    observerRef: observerRef,
    update: update
  };
};

/* harmony default export */ var useIntersectionObserver_useIntersectionObserver = (useIntersectionObserver);
;// CONCATENATED MODULE: ../../libs/utils/useIntersectionObserver/index.ts


/***/ }),

/***/ 78299:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ useNextPageTrigger_useNextPageTrigger; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utils/useIntersectionObserver/index.ts + 1 modules
var useIntersectionObserver = __webpack_require__(83194);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/utils/useNextPageTrigger/useNextPageTrigger.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}




/**
 * A hook that triggers the next page when the element is in view.
 * @param props.isLoading Whether the next page is loading.
 * @param props.onNextPage The function to call when the next page should be loaded.
 * @param props.loadMargin The margin to use when loading the next page.
 * @param props.totalDownloadedPages The total number of downloaded pages.
 * @param props.hasNextPage Whether there is a next page.
 * @param props.error The error that occurred while loading the next page.
 * @param props.NextPageTrigger The component to render as the next page trigger.
 * @returns The React component to render as the next page trigger.
 */

var useNextPageTrigger = function useNextPageTrigger(_ref) {
  var isLoading = _ref.isLoading,
      onNextPage = _ref.onNextPage,
      loadMargin = _ref.loadMargin,
      pageLength = _ref.totalDownloadedPages,
      hasNextPage = _ref.hasNextPage,
      error = _ref.error,
      _ref$NextPageTrigger = _ref.NextPageTrigger,
      NextPageTrigger = _ref$NextPageTrigger === void 0 ? DefaultNextPageTrigger : _ref$NextPageTrigger;
  var nextPageTriggerRef = (0,react.useRef)(null);
  var isInView = (0,react.useRef)(false);
  (0,useIntersectionObserver/* default */.Z)([nextPageTriggerRef], function (intersections) {
    var isInViewValue = intersections.some(function (i) {
      return i.isIntersecting;
    });
    isInView.current = isInViewValue;

    if (isLoading) {
      return;
    }

    if (isInViewValue && hasNextPage) {
      onNextPage === null || onNextPage === void 0 ? void 0 : onNextPage();
    }
  }, {
    rootMargin: loadMargin,
    threshold: [1]
  });
  (0,react.useEffect)(function () {
    if (!isLoading && isInView.current && hasNextPage) {
      // eslint-disable-next-line no-warning-comments
      // TODO: This `onNextPage()` call should be revisited since it is fetching pagination data twice
      // check out on /customers, /recipes, /catalog, /growth-masters/curriculum
      // Maybe we should remove this useEffect entirely and refactor this hook.
      onNextPage === null || onNextPage === void 0 ? void 0 : onNextPage();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [isLoading, pageLength, hasNextPage]); // Split it to simplify typescript compilation

  var El = NextPageTrigger;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(El, {
    ref: nextPageTriggerRef,
    error: error
  });
};

/* harmony default export */ var useNextPageTrigger_useNextPageTrigger = (useNextPageTrigger);

var DefaultNextPageTrigger = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e11u9tnv0"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);
;// CONCATENATED MODULE: ../../libs/utils/useNextPageTrigger/index.ts


/***/ }),

/***/ 72762:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/growth-masters/curriculum",
      function () {
        return __webpack_require__(58571);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3287,9097,6577,9137,8943,8530,1382,4136,2073,4274,7096,1367,948,4881,9524,3500,9833,9272,5250,9774,2888,179], function() { return __webpack_exec__(72762); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);